import React from 'react'
import { RecipesTable } from '../components/actions2/RecipesTable'

export const Recipes = () => {
    return <RecipesTable />
}
